module.exports = {
  "country": "NO",
  "artist": "Alexander Rybak",
  "song": "Fairytale",
  "year": "2009",
  "place": "1",
  "spotify": "3MnAsEBBsEj86d03RgO4EM"
};